<template>
  <div>
    <ghosthouse v-if="resultData.prefix === 'GH'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <solarspace v-if="resultData.prefix === 'SOLAR'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <joker v-if="resultData.prefix === 'JOKER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <monster v-if="resultData.prefix === 'MONSTER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <thaidessert v-if="resultData.prefix === 'TDESSERT'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <kraken v-if="resultData.prefix === 'KRAKEN'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <vampire v-if="resultData.prefix === 'VAMPIRE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <romaplus v-if="resultData.prefix === 'ROMAPLUS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <super-bros v-if="resultData.prefix === 'SUPERBROS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <jinsung v-if="resultData.prefix === 'JINSUNG'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <richwater v-if="resultData.prefix === 'RICHWATER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <snowprinces v-if="resultData.prefix === 'SNOWPRINCESS'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <angrybird v-if="resultData.prefix === 'ANGRYBIRD'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <sushi v-if="resultData.prefix === 'SUSHI35'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <crazyworm v-if="resultData.prefix === 'CRAZYWORM'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <doraemon v-if="resultData.prefix === 'DORAEMON'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <peekaboo v-if="resultData.prefix === 'PEAKABOO'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <warth-of-egypt v-if="resultData.prefix === 'EGYPT'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <grand-shine v-if="resultData.prefix === 'GRANDSHRINE'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <ninfruit v-if="resultData.prefix === 'FRUITNINJA'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <krahung v-if="resultData.prefix === 'HUNGRYKRAHUNG'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <shiba v-if="resultData.prefix === 'SHIBAMOGUL'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <guardian-wizard v-if="resultData.prefix === 'GUARDIANWIZARD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <hoyes-yellow v-if="resultData.prefix === 'HOYESYELLOW'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <shikkadood v-if="resultData.prefix === 'SHIKKADOOD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <bleesingox v-if="resultData.prefix === 'BLESSINGOX'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <moemoe v-if="resultData.prefix === 'MOEMOECUTE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <centilliongod v-if="resultData.prefix === 'CENTILLIONGOD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <dinopop v-if="resultData.prefix === 'DINOPOP'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <punkstar v-if="resultData.prefix === 'PUNKSTAR'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <squidgame v-if="resultData.prefix === 'SQUIDTOON'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <govdisco v-if="resultData.prefix === 'GOVDISCO'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :currentBet="currentBet" :currency="currency" :featureBuyMaximum="featureBuyMaximum"
      :isShowCurrencySymbol="isShowCurrencySymbol" />
    <blessing-tiger v-if="resultData.prefix === 'BLESSINGTIGER'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :currency="currency" :featureBuyMaximum="featureBuyMaximum" />
    <mermaid v-if="resultData.prefix === 'MERMAID'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <valentine-garden v-if="resultData.prefix === 'CUPIDGARDEN'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <virus v-if="resultData.prefix === 'VIRUS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <mjl v-if="resultData.prefix === 'MAHJONGLEGEND'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :currentBet="currentBet" :currency="currency" :featureBuyMaximum="featureBuyMaximum"
      :isShowCurrencySymbol="isShowCurrencySymbol" />
    <petrenger v-if="resultData.prefix === 'PETRANGER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <veggiesbonanza v-if="resultData.prefix === 'VEGGIESBONANZA'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <mafiaways v-if="resultData.prefix === 'MAFIAWAYS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <LuckyNangkwak v-if="resultData.prefix === 'LUCKYNANGKWAK'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <Dinogems v-if="resultData.prefix === 'DINOGEMS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <epicofaztec v-if="resultData.prefix === 'EPICOFAZTEC'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <kingdomz v-if="resultData.prefix === 'KINGDOM'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <fishingParadise v-if="resultData.prefix === 'FISHINGPARADISE'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <alice v-if="resultData.prefix === 'ALICE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <mahjongXmas v-if="resultData.prefix === 'MAHJONGXMAS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :currentBet="currentBet" :currency="currency" :featureBuyMaximum="featureBuyMaximum"
      :isShowCurrencySymbol="isShowCurrencySymbol" />
    <blessingDragon v-if="resultData.prefix === 'BLESSINGDRAGON'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <monkeyKing v-if="resultData.prefix === 'MONKEYKING'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <SubwayRunner v-if="resultData.prefix === 'SUBWAYRUNNER'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <GuardianWealth v-if="resultData.prefix === 'GUARDIANWEALTH'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <MAFIAWAYS2 v-if="resultData.prefix === 'MAFIAWAYS2'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :currency="currency" />
    <Tiki v-if="resultData.prefix === 'TIKI'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :currency="currency" />
    <ClashOfWars v-if="resultData.prefix === 'CLASHOFWARS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :currency="currency" />
    <NaturalAce v-if="resultData.prefix === 'NATURALACE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <AztecLegend v-if="resultData.prefix === 'AZTECLEGEND'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <mahjongLegacy v-if="resultData.prefix === 'MAHJONGLEGACY'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <SuperAceX v-if="resultData.prefix === 'SUPERACEX'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <mahjongPhoenix v-if="resultData.prefix === 'MAHJONGPHOENIX'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <AztecEmpire v-if="resultData.prefix === 'AZTECEMPIRE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <NekoReborn v-if="resultData.prefix === 'NEKOREBORN'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <RomaKingdom v-if="resultData.prefix === 'ROMAKINGDOM'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <Aztec1000 v-if="resultData.prefix === 'AZTEC1000'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <Olympus1000 v-if="resultData.prefix === 'OLYMPUS1000'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <Oneboxing v-if="resultData.prefix === 'BOXING'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <MahjongTiger v-if="resultData.prefix === 'MAHJONGTIGER'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />
    <GovJoke v-if="resultData.prefix === 'GOVJOKE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang"
      :betMinMax="betMinMax" :isShowCurrencySymbol="isShowCurrencySymbol" :currentBet="currentBet"
      :featureBuyMaximum="featureBuyMaximum" :featureBuyMultiplier="featureBuyMultiplier" :currency="currency" />

  </div>
</template>

<script>
import { FETCH_GAME_RESULT_REQUEST } from '../store/actions/report'
import Ghosthouse from './ruleGame/ghost';
import Solarspace from './ruleGame/solarSpace';
import Joker from './ruleGame/joker';
import Monster from './ruleGame/monster';
import Thaidessert from './ruleGame/thaiDessert';
import Kraken from './ruleGame/kraken';
import Vampire from './ruleGame/vampire.vue';
import Romaplus from './ruleGame/romaplus.vue';
import SuperBros from './ruleGame/superBros.vue';
import Jinsung from './ruleGame/jinsung';
import Richwater from './ruleGame/richwater.vue';
import Snowprinces from './ruleGame/snowprinces';
import Angrybird from './ruleGame/angrybird.vue';
import Sushi from './ruleGame/sushi.vue';
import Crazyworm from './ruleGame/crazyworm.vue';
import Doraemon from './ruleGame/doraemon.vue';
import Peekaboo from './ruleGame/peekaboo.vue';
import WarthOfEgypt from './ruleGame/warthOfEgypt.vue';
import GrandShine from './ruleGame/grandShine.vue';
import Ninfruit from './ruleGame/ninfruit.vue';
import Krahung from './ruleGame/krahung.vue';
import Shiba from './ruleGame/shiba.vue';
import GuardianWizard from './ruleGame/guardianWizard.vue';
import HoyesYellow from './ruleGame/hoyesYellow.vue';
import Shikkadood from './ruleGame/shikkadood.vue';
import Bleesingox from './ruleGame/blessingox.vue';
import Moemoe from './ruleGame/moemoe.vue';
import Centilliongod from './ruleGame/centilliongod.vue';
import Dinopop from './ruleGame/dinopop.vue';
import Punkstar from './ruleGame/punkstar.vue';
import Squidgame from './ruleGame/squidgame.vue';
import Govdisco from './ruleGame/govdisco.vue';
import BlessingTiger from './ruleGame/blessingTiger.vue';
import Mermaid from './ruleGame/mermaid.vue';
import ValentineGarden from './ruleGame/valentineGarden.vue';
import Virus from './ruleGame/virus.vue';
import Mjl from './ruleGame/mjl.vue';
import Petrenger from './ruleGame/petrenger.vue';
import Veggiesbonanza from './ruleGame/veggiesbonanza.vue';
import Mafiaways from './ruleGame/mafiaways.vue';
import LuckyNangkwak from './ruleGame/luckyNangkwak.vue';
import Dinogems from './ruleGame/dinogems.vue';
import Epicofaztec from './ruleGame/epicofaztec.vue';
import Kingdomz from './ruleGame/kingdomz.vue';
import fishingParadise from './ruleGame/fishingParadise.vue';
import Alice from './ruleGame/alice.vue';
import MahjongXmas from './ruleGame/mahjongXmas.vue';
import BlessingDragon from './ruleGame/blessingDragon.vue'
import MonkeyKing from './ruleGame/monkeyKing.vue'
import SubwayRunner from './ruleGame/subwayrunner.vue'
import GuardianWealth from './ruleGame/guardianWealth.vue';
import MAFIAWAYS2 from './ruleGame/mafiaways2.vue';
import Tiki from './ruleGame/tiki.vue';
import ClashOfWars from './ruleGame/clashofwars.vue';
import NaturalAce from './ruleGame/naturalace.vue';
import AztecLegend from './ruleGame/azteclegend.vue';
import mahjongLegacy from './ruleGame/mahjongLegacy.vue';
import SuperAceX from './ruleGame/superAceX.vue';
import mahjongPhoenix from './ruleGame/mahjongPhoenix.vue';
import AztecEmpire from './ruleGame/aztecempire.vue';
import NekoReborn from './ruleGame/nekoReborn.vue';
import RomaKingdom from './ruleGame/romaKingdom.vue';
import Aztec1000 from './ruleGame/aztec1000.vue';
import Olympus1000 from './ruleGame/olympus1000.vue';
import Oneboxing from './ruleGame/oneboxing.vue';
import MahjongTiger from './ruleGame/mahjongTiger.vue';
import GovJoke from './ruleGame/govjoke.vue';

export default {
  name: 'rulegame',
  props: {
    data: Object,
  },
  components: {
    Ghosthouse,
    Solarspace,
    Joker,
    Monster,
    Thaidessert,
    Kraken,
    Vampire,
    SuperBros,
    Jinsung,
    Richwater,
    Snowprinces,
    Angrybird,
    Sushi,
    Crazyworm,
    Doraemon,
    Peekaboo,
    WarthOfEgypt,
    GrandShine,
    Ninfruit,
    Krahung,
    Shiba,
    GuardianWizard,
    HoyesYellow,
    Shikkadood,
    Bleesingox,
    Romaplus,
    Moemoe,
    Centilliongod,
    Dinopop,
    Punkstar,
    Squidgame,
    Govdisco,
    BlessingTiger,
    Mermaid,
    ValentineGarden,
    Virus,
    Mjl,
    Petrenger,
    Veggiesbonanza,
    Mafiaways,
    LuckyNangkwak,
    Dinogems,
    Epicofaztec,
    Kingdomz,
    fishingParadise,
    Alice,
    MahjongXmas,
    BlessingDragon,
    MonkeyKing,
    SubwayRunner,
    GuardianWealth,
    MAFIAWAYS2,
    Tiki,
    ClashOfWars,
    NaturalAce,
    AztecLegend,
    mahjongLegacy,
    SuperAceX,
    mahjongPhoenix,
    AztecEmpire,
    NekoReborn,
    RomaKingdom,
    Aztec1000,
    Olympus1000,
    Oneboxing,
    MahjongTiger,
    GovJoke,
  },
  data() {
    return {
      prefix: '',
      resultData: {},
      errorModel: { code: null, message: '' }
    };
  },
  created() {
    this.setDefaultFavicon()
    this.queryPrefix();
    this.fetchGame();
  },

  methods: {
    queryPrefix() {
      const queryString = window.location.search;
      this.prefix = this.getParameterByName('prefix', queryString);
      this.$i18n.locale = this.getParameterByName('lang', queryString);
      this.betData = this.getParameterByName('bet', queryString);
      this.paytable = this.getParameterByName('paytable', queryString);
      this.imageLang = this.fixLang(this.getParameterByName('lang', queryString));
      this.currency = this.getParameterByName('currency', queryString);
      this.featureBuyMaximum = this.getParameterByName('featureBuyMaximum', queryString);
      this.featureBuyMultiplier = this.getParameterByName('featureBuyMultiplier', queryString);
      this.isShowCurrencySymbol = this.getParameterByName('isShowCurrencySymbol', queryString);
    },
    fixLang(lang) {
      if (lang === 'cn') return 'zh';
      else if (lang === 'en' || lang === 'th' || lang === 'zh') return lang;
      else return 'en';
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    setDefaultFavicon() {
      document.title = 'Askmeslot';
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = 'https://asset-images.asp78coll.com/sit/default/agent/favicon.svg';
    },

    async fetchGame() {
      let params = {
        prefix: this.prefix
      }
      await this.$store
        .dispatch(FETCH_GAME_RESULT_REQUEST, params)
        .then(res => {
          this.resultData = res.config;
          if (this.betData) {
            let Betdata = JSON.parse(this.betData);
            this.resultData.config.baseBet = Betdata.baseBet;
            this.resultData.config.betLevel = Betdata.betLevel;
            this.resultData.config.betSize = Betdata.betSize;
            this.currentBet = Betdata.currentBet;
            this.betMinMax = Betdata.betMinMax;
            this.featureBuyMaximum = Betdata.featureBuyMaximum;
            this.featureBuyMultiplier = Betdata.featureBuyMultiplier;
            this.isShowCurrencySymbol = Betdata.isShowCurrencySymbol;
          }
          if (this.paytable) {
            let paytable = JSON.parse(this.paytable);
            this.resultData.config.payTable = paytable;
          }
        })
        .catch(err => {
          console.error('err :>> ', err);
          this.errorModel.code = err.code
          this.errorModel.message = err.message
        })
    }

  },
};
</script>